/**
 * @file User / material analysis UI — pages/Dashboard/User/Home/components/UserHomeSteps.tsx.
 */

import React from "react";
import "../UserHome.css";

const UserHomeSteps: React.FC = () => {
  return (
    <div className="user-home-steps">
      <div className="user-step-card">
        <div className="user-step-icon">
          <img src="/images/step1_material_selection.PNG" alt="Material selection" />
        </div>
        <h3 className="user-step-title">Step 1: Material selection</h3>
        <p className="user-step-description">
          Start by selecting the construction material and its sub-type from the material library.
        </p>
        <div className="user-step-details">
          <p><strong>Material:</strong> Refers to primary construction materials such as cement, steel, concrete, bricks, etc.</p>
          <p><strong>Material Sub-type:</strong> Represents sub-classifications within a material, based on variations in: raw material composition, manufacturing technology or method, physical properties and forms.</p>
        </div>
      </div>

      <div className="user-step-card">
        <div className="user-step-icon">
          <img src="/images/step2_datapool.PNG" alt="Data pool generation" />
        </div>
        <h3 className="user-step-title">Step 2: Data pool generation</h3>
        <p className="user-step-description">
          Once a material is selected, the platform retrieves a representative embodied carbon value based on: Data Reliability, Generic or Defined Data Specificity.
        </p>
        <p className="user-step-note">
          This initial result is generated from a generic specificity data pool.
        </p>
      </div>

      <div className="user-step-card">
        <div className="user-step-icon">
          <img src="/images/step3_review.PNG" alt="Generic specificity result review" />
        </div>
        <h3 className="user-step-title">Step 3: Generic specificity result review</h3>
        <p className="user-step-description">
          At this stage, users can evaluate whether the generic embodied carbon value meets their needs.
        </p>
        <ul className="user-step-list">
          <li><strong>If you are satisfied:</strong> You may directly download the results.</li>
          <li><strong>If you are not satisfied:</strong> You may refine the analysis by defining additional data specificity parameters.</li>
        </ul>
      </div>
    </div>
  );
};

/** React component — User Home Steps. */
export default UserHomeSteps;
